module.exports = __webpack_public_path__ + "img/icn_left.fd0f9bd6.svg";